import { Contact } from '@/components/ContactForm';
import FormFieldComponent from '@/components/FormFieldComponent';
import FormFieldPhone from '@/components/FormFieldPhone';
import { EMAIL_ADDRESS_VALIDATION, NAME_VALIDATION } from '@/utils/constant';
import { Dispatch, FC } from 'react';
import { useFormContext } from 'react-hook-form';

interface ContactFormSectionProps {
  contacts: Contact[];
  currentContactIndex: number;
  activeContactId: string;
  setContacts: Dispatch<React.SetStateAction<Contact[]>>;
}

export const VendorContactFormSection: FC<ContactFormSectionProps> = ({
  contacts,
  currentContactIndex,
  activeContactId,
  setContacts,
}) => {
  const { control, getValues, setValue } = useFormContext();
  return (
    <div className="flex flex-col gap-6 mt-4">
      <div className="grid grid-cols-2 gap-6">
        <FormFieldComponent
          name={`contacts.${currentContactIndex}.firstName`}
          label="First Name"
          placeholder="Enter First Name"
          control={control}
          required
          onChange={(e) => {
            const newPersons = [...contacts];
            {
              const person = newPersons.find((p) => p.id === activeContactId);
              const lastName = (getValues(`contacts[${currentContactIndex}].lastName`) as string) ?? '';
              if (person) {
                person.name = e.target.value ?? '' + ' ' + lastName;
              }
            }
            setContacts(newPersons);
          }}
          {...NAME_VALIDATION}
        />
        <FormFieldComponent
          name={`contacts.${currentContactIndex}.lastName`}
          label="Last Name"
          placeholder="Enter Last Name"
          control={control}
          required
          onChange={(e) => {
            const newPersons = [...contacts];
            const firstName = getValues(`contacts[${currentContactIndex}].firstName`) as string;
            const person = newPersons.find((p) => p.id === activeContactId);
            if (person) {
              person.name = firstName ? firstName + ' ' + e.target.value : e.target.value;
            }
            setContacts(newPersons);
          }}
          {...NAME_VALIDATION}
        />
      </div>
      <div className="grid grid-cols-2 gap-6">
        <FormFieldComponent
          control={control}
          name={`contacts[${currentContactIndex}].email`}
          label="Email Address"
          placeholder="Enter Email Address"
          required
          {...EMAIL_ADDRESS_VALIDATION}
        />
        <FormFieldPhone
          name={`contacts[${currentContactIndex}].phone`}
          label="Phone Number"
          defaultCountry="us"
          onChange={(value) => {
            if (!value || value == '') {
              setValue(`contacts[${currentContactIndex}].extension`, undefined);
            }
          }}
        />
      </div>
    </div>
  );
};

export default VendorContactFormSection;
